import { ReactComponent as LineWidthIcon } from 'assets/icons/line_width.svg';
import { SliderPopover } from 'modules/common/components/ToolbarPopover';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { MenuProps } from '../../common/toolbar/TextToolbar.types';

const MIN_WIDTH = 0;
const MAX_WIDTH = 5;

export const BorderWidth = memo(({ onChange, value }: MenuProps) => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'tableToolbar' });
  const label = t('border.width.label');
  const handleChangeWidth = (newValue: number) => onChange(`${newValue}px`);

  return (
    <SliderPopover
      value={parseInt(value)}
      icon={<LineWidthIcon />}
      label={label}
      onChange={handleChangeWidth}
      suffix={'px'}
      max={MAX_WIDTH}
      min={MIN_WIDTH}
      title={label}
    />
  );
});
BorderWidth.displayName = 'BorderWidth';
